// extracted by mini-css-extract-plugin
module.exports = {"clipButton":"ClipButtonWrapper_clipButton___NJA2"};